
import React from 'react'
import styled from 'styled-components';
import tw from 'twin.macro';
import { isFieldsValid, useCreatePostStore, useFieldValue } from '..';
import { DPButton } from '../../../common/types';
import { fetchSubmit } from '../api';

interface Props extends DPButton {}

const SubmitButton = (props: Props) => {
	const requestProgress = useCreatePostStore((s) => s.reqestProgress)

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		if (isFieldsValid()) {
			fetchSubmit()
		}
	};

	return (
    <Button disabled={props.disabled} onClick={handleClick}>
      {requestProgress ? `${requestProgress}%` : "Submit"}
    </Button>
  );
}

const Button = styled.button(() => [
  tw`text-pink-600 text-[0.6rem] px-[0.5rem] py-[0.2rem] border-2 border-pink-400 rounded-sm `,
]);

export default SubmitButton